import React from "react";
import ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import { ApolloProvider } from "@apollo/react-hooks";
import { Provider } from "react-redux";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/reducer";
import { client } from "./grapghQl";
import { ToastProvider } from "./components/Toast";
import messages from "./ii8n/en.json";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTIC_ID, {
  gaOptions: {
    allowLinker: true,
  },
});

ReactGA.ga("require", "linker");
ReactGA.ga("linker:autoLink", [window.location.host]);

let locale = "en";
console.log('%cStop!\n%cThis is a browser feature intended for developers.\nIf someone told you to copy and paste something here, it could be dangerous.', 
  'color: red; font-size: 30px; font-weight: bold;', 
  'color: white; font-size: 16px; font-weight: normal;');

root.render(
    <IntlProvider locale={locale} messages={messages}>
      <Provider store={store}>
        <ApolloProvider client={client}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </ApolloProvider>
      </Provider>
    </IntlProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
